import { KitchenProcurementType } from 'models/procurement.model';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export type KitchenProcurementContextType = {
  procurementToUpdate: KitchenProcurementType;
  setProcurementToUpdate: Dispatch<SetStateAction<KitchenProcurementType>>;
};

export const KitchenProcurementContext = createContext({} as KitchenProcurementContextType);
const useKitchenProcurementContext = () => {
  const context = useContext(KitchenProcurementContext);
  return context;
};

export default useKitchenProcurementContext;
